module.exports = __webpack_public_path__ + "static/media/sumoapps.65271866.png";